import React, { createContext, useContext, useRef } from "react"
import { create, useStore } from "zustand"
import { deTherapyPrescriptionFragment$key } from "@/modules/patients/detail/therapy-prescription/de/services/__generated__/deTherapyPrescriptionFragment.graphql"

type State = {
  therapyPrescriptionId: string | null
  therapyPrescriptionRef: deTherapyPrescriptionFragment$key | null
}

type Actions = {
  setTherapyPrescription: (therapyPrescriptionId: string | null, ref: deTherapyPrescriptionFragment$key | null) => void
  reset: () => void
}

const initialState: State = {
  therapyPrescriptionId: null,
  therapyPrescriptionRef: null,
}

const createTherapyDrawerStore = () => {
  return create<State & Actions>((set) => ({
    ...initialState,
    setTherapyPrescription: (therapyPrescriptionId, ref) => set({ therapyPrescriptionId, therapyPrescriptionRef: ref }),
    reset: () => {
      set(initialState)
    },
  }))
}

type TherapyDrawerStoreType = ReturnType<typeof createTherapyDrawerStore>

const TherapyDrawerStoreContext = createContext<TherapyDrawerStoreType | null>(null)

type TherapyDrawerStoreProviderProps = React.PropsWithChildren

export const TherapyDrawerStoreProvider = ({ children }: TherapyDrawerStoreProviderProps) => {
  const storeRef = useRef<TherapyDrawerStoreType>(undefined)
  if (!storeRef.current) {
    storeRef.current = createTherapyDrawerStore()
  }
  return <TherapyDrawerStoreContext.Provider value={storeRef.current}>{children}</TherapyDrawerStoreContext.Provider>
}

export function useTherapyDrawerStoreContext<T>(selector: (state: State & Actions) => T): T {
  const store = useContext(TherapyDrawerStoreContext)
  if (!store) throw new Error("Missing TherapyDrawerStoreProvider in the tree")
  return useStore(store, selector)
}
